import * as THREE from 'three';
import * as TWEEN from '@tweenjs/tween.js';

const animateVector3 = ( vectorToAnimate, target, options ) => {

    options = options || {};

    var to = target ? ( options.relative ? vectorToAnimate.clone().add( target ) : target ) : THREE.Vector3(),
        easing = options.easing || TWEEN.Easing.Quadratic.In,
        duration = options.duration || 500;

    var tweenVector3 = new TWEEN.Tween( vectorToAnimate )
        .to({ x: to.x, y: to.y, z: to.z, }, duration )
        .easing( easing )
        .onUpdate( d => options.update && options.update( d ) )
        .onComplete( () => options.callback && options.callback() )
        .start()

    return tweenVector3
}

const animateQuaternion = ( quatToAnimate, target, options ) => {

    options = options || {};
    const quatStart = quatToAnimate.clone(),
          time = { t: 0 }

    const to = target || THREE.Quaternion(),
          easing = options.easing || TWEEN.Easing.Quadratic.In,
          duration = options.duration || 500;

    const tweenQuat = new TWEEN.Tween( time )
        .to( { t: 1 }, duration )
        .easing( easing )
        .onUpdate( d => {
            THREE.Quaternion.slerp( quatStart, to, quatToAnimate, time.t );
            options.update && options.update( d );
        })
        .onComplete( () => quatToAnimate.copy( to ) )
        .start()

    return tweenQuat

}

const animateColour = ( colToAnimate, target, options ) => {

    options = options || {};

    const to = target || THREE.Color( 0, 0, 0 ),
        easing = options.easing || TWEEN.Easing.Quadratic.In,
        duration = options.duration || 500;

    const tweenColour3 = new TWEEN.Tween( colToAnimate )
        .to( { r: to.r, g: to.g, b: to.b  }, duration )
        .easing( easing )
        .onUpdate( d => options.update && options.update( d ) )
        .onComplete( () => options.callback && options.callback() )
        .start()

    return tweenColour3

}

const animLib = {

    'Master Power Switch': obj => animateQuaternion( obj.quaternion, new THREE.Quaternion( 0.119, 0, 0, 0.993 ), { duration: 200 } ),
    'Water Chiller Power': ( obj, scene ) => {
        animateQuaternion( obj.quaternion, new THREE.Quaternion( -0.707, 0, 0, 0.707 ) );
        animateColour( scene.getObjectByName( 'Water Chiller Screen STATIC' ).material.emissive, new THREE.Color( 1, 0, 0 ) );
    },
    'Water Chiller Display': ( obj, scene ) => {
        animateColour( scene.getObjectByName( 'Water Chiller Screen STATIC' ).material.emissive, new THREE.Color( 0, 1, 0 ) );
    },
    'Galden Chiller Power': ( obj, scene ) => {
        animateQuaternion( obj.quaternion, new THREE.Quaternion( -0.707, 0, 0, 0.707 ) );
        animateColour( scene.getObjectByName( 'Galden Chiller Light STATIC' ).material.emissive, new THREE.Color( 1, 0, 0 ) )
    },
    'NMR Heater Power': obj => {
        animateQuaternion( obj.quaternion, new THREE.Quaternion( -0.707, 0, 0, 0.707 ) )
    },
    'Air Flow Valve': obj => animateQuaternion( obj.quaternion, new THREE.Quaternion( 0, 0, -0.707, 0.707 ) ),
    'PC': obj => {
        animateVector3( obj.position, new THREE.Vector3( -0.3, 0, 0 ), { relative: true, callback: () => animateVector3( obj.position, new THREE.Vector3( 0.3, 0, 0 ), { relative: true } ) } );
        animateColour( obj.material.emissive, new THREE.Color( 0.3, 1, 0.3 ) );
    },
    'TX': obj => {
        animateVector3( obj.position, new THREE.Vector3( -0.3, 0, 0 ), { relative: true, callback: () => animateVector3( obj.position, new THREE.Vector3( 0.3, 0, 0 ), { relative: true } ) } );
        animateColour( obj.material.emissive, new THREE.Color( 0.7, 0.7, 0.3 ) );
    },
    'Sample Holder': ( obj, scene ) => {
        animateVector3( scene.getObjectByName( 'SampleTube STATIC' ).position, new THREE.Vector3( 0, -6, 0 ), { duration: 750, relative: true, callback: () => {
            animateVector3( scene.getObjectByName( 'SampleTube STATIC' ).position, new THREE.Vector3( 0, 6, 0 ), { duration: 750, relative: true } );
            animateVector3( scene.getObjectByName( 'SampleCap STATIC' ).position, new THREE.Vector3( 0, 6, 0 ), { duration: 750, relative: true } );
        } } );
    },
    'Sample Entry': ( obj, scene ) => {
        scene.getObjectByName( 'SampleTube STATIC' ).position.set( 18.9, 42.9, -48.6 );
        scene.getObjectByName( 'SampleCap STATIC' ).position.set( 18.9, 42.9, -48.6 );
        animateVector3( scene.getObjectByName( 'SampleTube STATIC' ).position, new THREE.Vector3( 0, -5, 0 ), { duration: 750, relative: true } );
        animateVector3( scene.getObjectByName( 'SampleCap STATIC' ).position, new THREE.Vector3( 0, -5, 0 ), { duration: 750, relative: true } );
    },
    'Sample Weight': ( obj, scene ) => {
        obj.position.set( 2.55, 4.67, -4.16 );
        animateVector3( obj.position, new THREE.Vector3( 0, -4, 0 ), { duration: 750, relative: true } );
    }

}

export { animateVector3, animateQuaternion, animLib }
